import { Flex, Typography } from "antd";
import React from "react";

const ShortlistedMessage = () => {
  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={{ margin: "0 auto", textAlign: "center", height: "100%" }}
    >
      <img src="/assets/thumb-up-animated.gif" alt="thumb-up" />
      <Typography.Text style={{ fontSize: "16px", lineHeight: "1.5" }}>
        Congratulations! 🎉 You've been shortlisted for this position. Our team
        will review your profile and get in touch with you soon about the next
        steps in the hiring process. Stay tuned!
      </Typography.Text>
    </Flex>
  );
};

export default ShortlistedMessage;
